import jQuery from "jquery";

const $ = jQuery;

const advancedEditorialBlock = (function($) { // eslint-disable-line

  const me = {};

  const isInViewport = (el) => {
    const elementTop = $(el).offset().top;
    const elementBottom = elementTop + $(el).outerHeight();

    const viewportTop = $(window).scrollTop();
    const viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
  };

  const VideoHandler = () => {
    const videoEl = $('.advanced-editorial-block__video .advanced-editorial-block__video__wrapper video', '.advanced-editorial-block');

    videoEl.each((_, el) => {
      const video = $(el);

      // check if this is mobile and bail out if true
      if (window.matchMedia('(max-width: 767px)').matches) {
        return;
      }

      const v = video[0];

      if (video.hasClass('video--loaded') == false) {
        video.addClass('video--loaded');

        for (const source in v.children) {
          const videoSource = v.children[source];
          if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
            videoSource.src = videoSource.dataset.src;
          }
        }

        v.load();
        v.pause();
        v.currentTime = 0;
      }

      if (video.closest('.advanced-editorial-block__video').is(':visible') == false || isInViewport(video) == false) {
        return;
      }

      if (video.hasClass('video--playing') == false) {
        video.addClass('video--playing');
        v.play();
      }
    });
  };

  me.init = () => {
    setTimeout(() => {
      VideoHandler();
    });

    $(window).on('resize', () => {
      VideoHandler();
    });

    $(window).on('scroll', () => {
      VideoHandler();
    });
  };

  return me;

}(jQuery));

export default advancedEditorialBlock;
